$(document).ready(function() {
  addToCartCollection();
})

function addToCartCollectionHandler()
{
  $('#add-to-cart-collection').on('click', function(e) {
    e.preventDefault();
    var productsObject = {};
    // console.log("in click")
    $('.collection-qty').each(function(index) {
      // console.log($(this).data('variant-id'));
      var variantId = $(this).data('variant-id');
      var qty = parseInt($(this).val());
      if (qty > 0) {
        productsObject[variantId] = qty;
      }
    })
    // console.log(productsObject);
    var updateProductData = {updates: productsObject }
    // console.log(updateProductData);
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: updateProductData,

      success: function(cart) {
        // console.log(cart.items_count)
        // window.location.replace("/cart");
        $('#cart-count').css('display', 'inline-block');
        $('#cart-count').html('Go To Cart (' + cart.item_count + ')');
        $('#CartCount > span:nth-child(1)').html(cart.item_count);
        $('#cart-success').fadeIn(1000);
        setTimeout(function() {
          $('#cart-success').fadeOut(1000);
        }, 3000)
      },

      error: function(response) {
        console.log('error');
        $('#cart-error').fadeIn(1000);
        setTimeout(function() {
          $('#cart-error').fadeOut(1000);
        }, 3000)
        // console.log(response);
      }
    })
  })
}

// adding cart way instead of "updating"
function addToCartCollection()
{
  $('#add-to-cart-collection').on('click', function(e) {
    e.preventDefault();
    Shopify.queue = [];
    $('.collection-qty').each(function(index) {
      var variantId = $(this).data('variant-id');
      var qty = parseInt($(this).val());
      if (qty > 0) {
        Shopify.queue.push( {
          variantId: variantId,
          quantity: qty
        } );
      }
    });
    Shopify.moveAlong = function() {
      // If we still have requests in the queue, let's process the next one.
      if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        data = {
          id: request.variantId,
          quantity: request.quantity
        }
        $.ajax({
          type: "POST",
          url: '/cart/add.js',
          dataType: 'json',
          data: data,
          success: function(res) {
            // call the function again when the callback is complete
            $('.collection-qty').val("")
            Shopify.moveAlong();   
          },
          error: function() {
            if (Shopify.queue.length){
		            Shopify.moveAlong()
		        } else {
              $('#cart-error').fadeIn(1000);
              setTimeout(function() {
                $('#cart-error').fadeOut(1000);
              }, 3000);
            }
          }
        })

      }
      // If the queue is empty we will get the cart contents and update cart count
      else {
        $.getJSON('/cart.js', function() {

        })
        .done(function( cart ) {
          $('#cart-count').css('display', 'inline-block');
          $('#cart-count').html('Go To Cart (' + cart.item_count + ')');
          $('#CartCount > span:nth-child(1)').html(cart.item_count);
          $('#cart-success').fadeIn(1000);
          setTimeout(function() {
            $('#cart-success').fadeOut(1000);
          }, 3000)
        })
        .fail(function(){
          $('#cart-error').fadeIn(1000);
          setTimeout(function() {
            $('#cart-error').fadeOut(1000);
          }, 3000);
        });
      }
    };
    // call the function
    Shopify.moveAlong();
  });
}

// for ajax functionality later
// function clearCartHandler() {
//   $('#clear-cart').on('click', function(e) {
//     e.preventDefault()
//     $.ajax({
//       type: "POST",
//       url: '/cart/clear.js',
//       dataType: 'json',
//       success: function(){
//
//       },
//     });
//   })
// }
